import React, { useState, useEffect } from 'react';
import './index.less';
import CheckBox from '../../../assets/images/checkbox.png';
import { ReactComponent as Volume } from '../../../assets/icons/volume-lound.svg';
import { ReactComponent as MicrophoneComp } from '../../../assets/icons/microphone.svg';
import ModelDesk from '../components/deskModal/index';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import sendGaEvent from '@/ga';

export default function BeforeRecording(props) {
  const { t } = useTranslation('screenRecorder');
  const [isOpenDesk, setIsOpenDesk] = useState(false);

  useEffect(() => {
    sendGaEvent({
      category: 'enter_sr_page',
      action: 'enter_start_record_page',
    });
  }, []);

  const closeModal = () => {
    setIsOpenDesk(false);
  };
  const {
    Microphone = false, //麦克风选项是否选中
    setMicrophone, //更改麦克风选项方法
    sysAudio, //系统音频选中
    setSysAudio, //更改系统音频选项
    onStartRecord, //开始录屏
    showToast, //是否显示提示
  } = props;

  const onGetMic = (e) => {
    setMicrophone(e);
  };

  const onGetAudio = (e) => {
    setSysAudio(e);
  };

  return (
    <div className='beforeRecording'>
      <div className='screenTitle'>{t('OnlineScreen')}</div>
      <div className='screenSubTitle'>{t('RecordScreenWithAudio')}</div>
      <div className='screenChoose'>
        <div
          onClick={() => onGetAudio(!sysAudio)}
          className={`screenType ${sysAudio ? 'isSelect' : ''} ${
            showToast ? 'disabled' : ''
          }`}
        >
          <Volume className='volumeComp' />

          <span className='screenText'>{t('SystemAudio')}</span>
          <div className='checkBox'>
            {sysAudio ? <img src={CheckBox} alt='' /> : ''}
          </div>
        </div>
        <div
          onClick={() => onGetMic(!Microphone)}
          className={`screenType ${Microphone ? 'isSelect' : ''} ${
            showToast ? 'disabled' : ''
          }`}
        >
          <MicrophoneComp className='microphoneComp' />
          <span className='screenText'>{t('Microphone')}</span>
          <div className='checkBox'>
            {Microphone ? <img src={CheckBox} alt='' /> : ''}
          </div>
        </div>
      </div>

      <div className='startRecording'>
        <Button
          disabled={showToast}
          className='startBtn'
          onClick={() => onStartRecord()}
        >
          {t('StartRecording')}
        </Button>
      </div>
      <ModelDesk
        type='screen'
        isOpenDesk={isOpenDesk}
        closeModal={closeModal}
      />
    </div>
  );
}
